import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ThemeService } from '../../services/theme.service';

/** Boton sol/luna que alterna el tema de la consola. */
@Component({
  selector: 'app-theme-toggle',
  imports: [],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeToggleComponent {
  private readonly themeService = inject(ThemeService);

  protected readonly theme = this.themeService.theme;
  protected readonly isDark = computed(() => this.theme() === 'dark');

  /** El texto describe la ACCION, no el estado: es lo que pasara al pulsar. */
  protected readonly label = computed(() =>
    this.isDark() ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro',
  );

  protected toggle(): void {
    this.themeService.toggle();
  }
}
